import styled from 'styled-components';
import { COLOR, TYPOGRAPHY } from '../../../../theme/constants';
import { FlexContainer } from '@emarketer/componentlibrary';

export const TemplateWrapper = styled.div`
  cursor: pointer;
`;

export const Template = styled.div`
  display: inline-block;
  width: 100%;
  font-size: 13px;
  text-decoration: none;
  color: ${COLOR.BLACK};

  @media only screen and (min-width: 1340px) {
    font-size: 14px;
  }
`;

export const TemplateRadio = styled(FlexContainer)`
  > div {
    min-width: 60px;
  }
  svg {
    width: auto !important;
    vertical-align: baseline;
  }
`;

export const TemplateRadioPicker = styled.input`
  margin: 0;
  height: 14px;
  width: 14px;
`;

export const TemplateTitle = styled.a<{ selected: boolean }>`
  ${(props) => (props.selected ? `color: ${COLOR.BLUE}; ${TYPOGRAPHY.BOLD}` : '')};
  line-height: 18px;
  text-decoration: none;
  font-size: 16px;
  font-weight: 400;
  color: ${COLOR.BLACK};
  pointer-events: none;
  text-decoration: none;
`;

export const TemplateTag = styled.div`
  display: inline-block;
  font-size: 10px;
  color: ${COLOR.WHITE};
  ${TYPOGRAPHY.LIGHT};
  padding-top: 1px;
  background-color: ${COLOR.BLUE};
  border-radius: 8px;
  padding: 2px 7px;
`;
